<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Test Sets",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Tests",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Sets",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Set Name",
          sortable: true,
        },
        {
          key: "short",
          label: "Short Name",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        name: "",
        short: "",
      },
      deletedata: {
        name: "",
        id: "",
      },
      editdata: {
        name: "",
        short: "",
        id: "",
      },
      existingSet: [],
      nameError: "",
      shortError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("coursework", ["AllSets", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.AllSets ? this.AllSets.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.AllSets ? this.AllSets.length : 1;
  },
  methods: {
    ...mapActions({
      FetchSets: "coursework/fetchSets",
      AddSet: "coursework/addSet",
      EditSet: "coursework/editSet",
      DeleteSets: "coursework/deleteSet",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.AllSets ? this.AllSets.length : 1;
      this.currentPage = 1;
    },

    resetError() {
      this.nameError = "";
      this.shortError = "";
    },

    resetAddModal() {
      this.data.name = "";
      this.data.short = "";
      this.resetError();
    },
    resetEditModal() {
      this.editdata.name = "";
      this.editdata.short = "";
      this.resetError();
    },
    resetDeleteModal() {
      this.deletedata.name = "";
      this.deletedata.id = "";
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingSet = this.AllSets
          ? this.AllSets.filter((subj) => {
              return subj.name.toUpperCase() == this.data.name.toUpperCase();
            })
          : [];
        if (this.existingSet.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingSet = [];
      }
    },
    addSet(modal) {
      if (this.data.name == "") {
        this.nameError = "Set Name field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.short == "") {
        this.shortError = "Set Short Name field can't be empty";
        return;
      } else {
        this.shortError = "";
      }
      if (this.existingSet.length) {
        this.nameError = this.data.name + " exists already Please";
        return;
      } else {
        this.nameError = "";
      }
      this.modal = modal;
      this.AddSet(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editdata.id = values.item.id;
      this.editdata.name = values.item.name;
      this.editdata.short = values.item.short;
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.name;
    },
    deleteSet(modal) {
      this.modal = modal;
      this.DeleteSets(this.deletedata);
      this.closeModal(modal);
    },
    editSet(modal) {
      if (this.editdata.name == "") {
        this.nameError = "Set field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (this.editdata.short == "") {
        this.shortError = "Set Short Name field can't be empty";
        return;
      } else {
        this.shortError = "";
      }
      this.modal = modal;
      this.EditSet(this.editdata);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchSets();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_test_sets')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  List of Available Test Sets
                </h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-set-modal
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_test_sets')
                    )
                  "
                  class="btn btn-sm btn-primary float-end"
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="AllSets"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-set-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_test_sets')
                        )
                      "
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-set-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_test_sets')
                        )
                      "
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-set-modal"
        hide-footer
        @hidden="resetAddModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_test_sets')
          )
        "
      >
        <template #modal-title> Add New Test Set </template>
        <div class="form-group mb-3">
          <label>Set Name</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Test Name"
              class="form-control"
              @keyup="checkName"
              @input="resetError"
              v-model="data.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Short Name</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Short Name"
              class="form-control"
              @keyup="checkName"
              @input="resetError"
              v-model="data.short"
            />
          </div>
          <div class="text-danger" v-if="shortError">
            <em>{{ shortError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('add-set-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="addSet('add-set-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-set-modal"
        hide-footer
        @hidden="resetEditModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_test_sets')
          )
        "
      >
        <template #modal-title> Edit Set {{ editdata.name }}</template>
        <div class="form-group mb-3">
          <label>Set Name</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError"
              v-model="editdata.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Short Name</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Short Name"
              class="form-control"
              @keyup="checkName"
              @input="resetError"
              v-model="editdata.short"
            />
          </div>
          <div class="text-danger" v-if="shortError">
            <em>{{ shortError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('edit-set-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
            @click="editSet('edit-set-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete set starts -->
      <b-modal
        id="delete-set-modal"
        hide-footer
        @hidden="resetDeleteModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_test_sets')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger">
            Delete Test Set {{ deletedata.name }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete Set {{ deletedata.name }}? Click Proceed
              Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-set-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            @click="deleteSet('delete-set-modal')"
          >
            <b-spinner
              v-if="SaveStatus"
              variant="primary"
              small
              label="Deleting"
            ></b-spinner>
            <i class="fa fa-trash"></i> Confirm
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
